import React from "react";
import {Link} from "react-router-dom";

interface ToastBodyProps {
  title?: string;
  message?: string;
  link?: string;
  when?: string;
}

export const ToastBody: React.FC<ToastBodyProps> = ({title, message, link, when = "now"}) => (
  <>
    <div className="toast-header">
      <strong className="me-auto">{title}</strong>
      <small className="text-muted">{when}</small>
      <button type="button" className="ml-2 mb-1 btn-close" data-dismiss="toast" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    {link ? (
      <Link to={link} title={message}>
        <div className={"toast-body link"}>{message}</div>
      </Link>
    ) : (
      <div className="toast-body">{message}</div>
    )}
  </>
);
